module.exports = __webpack_public_path__ + "img/Yellow.d2043edb.svg";